import { useTheme } from "@mui/material";
import {
  BuildingIcon,
  CampusIcon,
  CopyIcon,
  DisticIcon,
  HomeIcon,
  PasteIcon,
  PoliciesIcon,
  SettingIcon,
  SingleUserIcon,
  StaffIcon,
  StudentIcon,
  UserIcon,
  DeleteIcon,
  DomainIcon,
  ExportIcon,
  ArchiveIcon,
} from "components/icon";
import { getColors } from "utils";
import EmergencyOutlinedIcon from "@mui/icons-material/EmergencyOutlined";
import DoDisturbRoundedIcon from '@mui/icons-material/DoDisturbRounded';

const SelectIcon = ({ value, error = false,selected = true, sx = {} }) => {
  const theme = useTheme();
  const { iconColor } = getColors(theme, "common");
  let custom_sx = { ...sx };
  if (selected) {
    custom_sx["color"] = iconColor;
  }
  switch (value) {
    case "copyIcon":
    case "CopyIcon":
      return <CopyIcon sx={{ ...custom_sx }} />;
    case "pasteIcon":
    case "PasteIcon":
      return <PasteIcon sx={{ ...custom_sx }} />;
    case "SingleUserIcon":
    case "singleUserIcon":
      return <SingleUserIcon sx={{ ...custom_sx }} />;
    case "DisticIcon":
    case "disticIcon":
      return <DisticIcon sx={{ ...custom_sx }} />;
    case "UserIcon":
    case "userIcon":
      return <UserIcon sx={{ ...custom_sx }} />;
    case "CampusIcon":
    case "campusIcon":
      return <CampusIcon sx={{ ...custom_sx }} />;
    case "BuildingIcon":
    case "buildingIcon":
      return <BuildingIcon sx={{ ...custom_sx }} />;
    case "homeIcon":
    case "HomeIcon":
      return <HomeIcon sx={{ ...custom_sx }} />;
    case "staffIcon":
    case "StaffIcon":
      return <StaffIcon sx={{ ...custom_sx }} />;
    case "studentIcon":
    case "StudentIcon":
      return <StudentIcon sx={{ ...custom_sx }} />;
    case "settingIcon":
    case "SettingIcon":
      return <SettingIcon sx={{ ...custom_sx }} />;
    case "policiesIcon":
    case "PoliciesIcon":
      return <PoliciesIcon sx={{ ...custom_sx }} />;
    case "incidentIcon":
    case "IncidentIcon":
      return <EmergencyOutlinedIcon sx={{ ...custom_sx }} />;
    case "domainIcon":
    case "DomainIcon":
      return <DomainIcon sx={{ ...custom_sx }} />;
    case "deleteIcon":
    case "DeleteIcon":
      return <DeleteIcon sx={{ ...custom_sx }} />;
    case "deactivateIcon":
    case "DeactivateIcon":
      return <DoDisturbRoundedIcon sx={{ ...custom_sx }} />;
    case "archiveIcon":
    case "ArchiveIcon":
      return <ArchiveIcon sx={{ ...custom_sx }} />;
    case "exportCsvIcon":
    case "ExportCsvIcon":
      return <ExportIcon sx={{ ...custom_sx }} />;

    default:
      return <SingleUserIcon sx={{ ...custom_sx }} />;
  }
};

export default SelectIcon;
